window.Sparkle ??= {};

Sparkle.FormDataUploader = class FormDataUploader {
  constructor(callbacks) {
    this.upload = this.upload.bind(this);
    this.callbacks = jQuery.extend(
      {
        success() {},
        progress() {},
        error() {},
      },
      callbacks,
    );
  }

  upload(url, formData) {
    return jQuery.ajax({
      url,
      data: formData,
      processData: false,
      contentType: false,
      type: "POST",
      success: this.callbacks.success,
      error: this.callbacks.error,
      xhr: () => {
        const request = jQuery.ajaxSettings.xhr();
        request.upload.addEventListener("progress", (event) => this.callbacks.progress(event), false);

        return request;
      },
    });
  }
};
